module.exports = __webpack_public_path__ + "img/Bodice-Front-B9-Da-Ea.2cfe2eb0.png";